import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOrdersPayloadState } from '@app-store/slices/companyStatistics/orders'

interface TaskAction extends Action {
    payload: IOrdersPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.orders

function* ordersSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/orders`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* ordersSaga(): any {
    yield takeLatest<TaskAction>(onRequest, ordersSagaTask)
}

export default ordersSaga
